import { ImgBucket } from './img-bucket'
import { StorageBucketConfig } from './storage-bucket-config'

export class ImgKey {

  public bucket: ImgBucket

  constructor(data: StorageBucketConfig, public img_key: string) {
    this.bucket = new ImgBucket(data)
  }

  get img_url(): string {
    return this.bucket.get_url(this.img_key)
  }

  public img_url_of_width(width: number): string {
    return this.bucket.get_url_of_width(this.img_key, width)
  }

  public img_url_of_height(height: number): string {
    return this.bucket.get_url_of_height(this.img_key, height)
  }

  public img_url_of_quality(quality: number): string {
    return this.bucket.get_url_of_quality(this.img_key, quality)
  }

  public img_url_of_square(width: number): string {
    return this.bucket.get_url_of_square(this.img_key, width)
  }

  public img_url_wq(width: number, quality: number): string {
    return this.bucket.get_url_wq(this.img_key, width, quality)
  }

  get has_image(): boolean {
    return Boolean(this.img_key)
  }

}



// WEBPACK FOOTER //
// ./src/app/models/media/img-key.ts